import { motion } from 'framer-motion';
import V1_1 from '../../assets/images/home/vector1/vector1-1.svg';
import V1_2 from '../../assets/images/home/vector1/vector1-2.svg';
import V1_3 from '../../assets/images/home/vector1/vector1-3.svg';
import V1_4 from '../../assets/images/home/vector1/vector1-4.svg';
import V1_5 from '../../assets/images/home/vector1/vector1-5.svg';
import V1_6 from '../../assets/images/home/vector1/vector1-6.svg';

const Vector1 = () => {
  return (
    <motion.div className="vector" id="vector1"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
    >
      <img src={V1_1} alt="Décoration à gauche" />
      <img src={V1_2} alt="Décoration à gauche" />
      <img src={V1_3} alt="Décoration à gauche" />
      <img src={V1_4} alt="Décoration à gauche" />
      <img src={V1_5} alt="Décoration à gauche" />
      <img src={V1_6} alt="Décoration à gauche" />
    </motion.div>
  );
};

export default Vector1;